import React from "react";

const HomeSectionSvgOrange = () => (
  <svg viewBox="0 0 1580 1600" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <style>
        {`.cls-1 {
          fill: url(#radial-gradient);
          stroke-width: 0px;
        }`}
      </style>
      <radialGradient id="radial-gradient" cx="720" cy="800" r="800" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="white"/> {/* More orange color */}
        <stop offset="1" stopColor="#000" stopOpacity="0"/>
      </radialGradient>
    </defs>
    <rect className="cls-1" x="0" y="0" width="1580" height="1600"/>
  </svg>
);

export default HomeSectionSvgOrange;
